import {combineEpics} from 'redux-observable';

import {
    getBannerHostPortEpic,
    getFavoritesTreeEpic,
    getMarketLimitEpic,
    getTreeLineEpic,
    getAllTreeEpic,
    getTreeLiveEpic,
    getTreeRatingEpic,
    getTreeResultEpic,
    loadNotCalculatedStepsEpic,
    loadOneFixtureEpic,
    loadPlayerInfoEpic,
    loadPlayerSettingsEpic,
    loadSportsEpic,
    loadStepsEpic,
    saveCouponEpic,
    savePlayerSettingsEpic,
    treePollingEpic
} from './spirs/epics';

export const rootEpic = combineEpics(loadOneFixtureEpic,
    loadSportsEpic,
    loadPlayerInfoEpic,
    loadPlayerSettingsEpic,
    savePlayerSettingsEpic,
    loadStepsEpic,
    saveCouponEpic,
    loadNotCalculatedStepsEpic,
    getFavoritesTreeEpic,
    getTreeLineEpic,
    getAllTreeEpic,
    treePollingEpic,
    getTreeRatingEpic,
    getTreeResultEpic,
    getTreeLiveEpic,
    getBannerHostPortEpic,
    getMarketLimitEpic
);
